import type {
  FooterWidget,
  GetNextBuyflowStepResponse,
  WifiSetupWidget,
} from '@/lib/TypesOpenApi';
import {proxy, useSnapshot} from 'valtio';
import {
  type StepWidgetStore,
  StepsPath,
  stepsMap,
} from '../routing/StepsRouting';
import {useWidget} from '../routing/StepsWizardContext';

const widget = stepsMap['WIFI_SETUP']!.store;

export interface WifiSetupPageWidget {
  widget: StepWidgetStore;
  content?: GetNextBuyflowStepResponse;
  wifiSetupWidget?: WifiSetupWidget;
  footerWidget?: FooterWidget;
}

export const wifiSetupWidget = proxy<WifiSetupPageWidget>({
  widget,
  get content() {
    return this.widget.content;
  },
  get wifiSetupWidget() {
    const widgets =
      widget.content?.buyflowStep.buyflowWidgets
        ?.map(({wifiSetupWidget: w}) => w!)
        .filter(w => !!w) || [];
    return widgets[0];
  },
  get footerWidget() {
    const widgets =
      widget.content?.buyflowStep.buyflowWidgets
        ?.map(({footerWidget: w}) => w!)
        .filter(w => !!w) || [];
    return widgets[0];
  },
});

export const useWifiSetupWidget = () =>
  useWidget(StepsPath.WifiSetup, wifiSetupWidget);

export interface WifiSetupState {
  networkName?: string;
  networkPassword?: string;
}

// if add any new field, add the new field to the below reset function also
export const store = proxy<WifiSetupState>({
  networkName: undefined,
  networkPassword: undefined,
});

export const resetWifiSetupState = () => {
  store.networkName = undefined;
  store.networkPassword = undefined;
};

export const useWifiSetupState = () => useSnapshot(store);

export const setWifiSetupState = (name: string, password: string) => {
  store.networkName = name;
  store.networkPassword = password;
};
